import * as React from "react";
import { useMediaQuery } from "react-responsive";
import { ArrowList } from "../../arrow-list/arrow-list/arrow-list.mjs";
import "debounce";
import "tabbable";
import { useIsMounted } from "../../helpers/helper/hooks/use-is-mounted.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Tabs } from "../../tabs/tabs/tabs.mjs";
import { useTheme } from "../../helpers/theme-provider/use-theme.mjs";
import { TabModalItem } from "../tab-modal-item/tab-modal-item.mjs";
const TabModal = (props) => {
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentProps: props, componentName: "TabModal", defaultValueName: "defaultCurrentTab", valueName: "currentTab", onChangeNames: "onTabChange" }, /* @__PURE__ */ React.createElement(TabModalInner, { ...props }));
};
const TabModalContext = React.createContext({
  renderedElement: "tabs",
  currentTab: null,
  setCurrentTab: (
    /* istanbul ignore next */
    () => null
  ),
  variant: "dark"
});
const TabModalInner = (props) => {
  const { currentTab: currentTabProp, defaultCurrentTab, onTabChange, breakPoint = "sm", variant = "dark", align, children, className, ...rest } = props;
  const isMounted = useIsMounted();
  const { media } = useTheme();
  const isLargeScreen = useMediaQuery({
    minWidth: media.width[breakPoint].min
  });
  const isInitial = React.useRef(true);
  const [internalCurrentTab, setInternalCurrentTab] = React.useState(defaultCurrentTab);
  const isCurrentTabControlled = React.useCallback(
    (currentTab2 = currentTabProp) => {
      return !!onTabChange && typeof currentTab2 !== "undefined";
    },
    [onTabChange, currentTabProp]
  );
  const currentTab = isCurrentTabControlled(currentTabProp) ? currentTabProp : internalCurrentTab;
  const renderedElement = isMounted && !isLargeScreen ? "modal" : "tabs";
  const setCurrentTab = React.useCallback(
    (tab) => {
      if (!isCurrentTabControlled()) {
        setInternalCurrentTab(tab);
      }
      onTabChange == null ? void 0 : onTabChange(tab);
    },
    [isCurrentTabControlled, onTabChange]
  );
  React.useEffect(() => {
    if (!isLargeScreen && isInitial.current) {
      setCurrentTab(null);
      isInitial.current = false;
    }
  }, [isLargeScreen, setCurrentTab]);
  return /* @__PURE__ */ React.createElement(
    TabModalContext.Provider,
    {
      value: {
        renderedElement,
        currentTab,
        setCurrentTab,
        variant
      }
    },
    renderedElement === "tabs" ? /* @__PURE__ */ React.createElement(
      Tabs,
      {
        ...rest,
        align,
        currentTab: currentTab != null ? currentTab : defaultCurrentTab,
        onTabChange: (_, nextTab) => setCurrentTab(nextTab),
        disableAnalyticsTrigger: true,
        navigationType: "button-navigation",
        itemComponent: TabModalItem
      },
      children
    ) : /* @__PURE__ */ React.createElement(ArrowList, { outerBordered: true, className }, children)
  );
};
export {
  TabModal,
  TabModalContext
};
